export const ADD_TIMEZONES = 'ADD_TIMEZONES'
export const ADD_OPENING_DAYS = 'ADD_OPENING_DAYS'